export const DEFAULT_CHARACTER = {
  name: "",
  imageUrl: "",
  level: 1,
  class: "",
  subclass: "",
  ability_scores: {
    strength: 8,
    dexterity: 8,
    constitution: 8,
    intelligence: 8,
    wisdom: 8,
    charisma: 8,
  },
  background: "",
  heritage: "",
  hit_points: 0,
  current_hit_points: 0,
  current_hit_dice: 1,
  discord_user_id: "",
  feat_choices: {},
  asi_choices: {},
  heritage_choices: {},
  subclass_choices: {},
  classChoices: {},
  toolProficiencies: [],
  additionalFeats: [],
  additionalASI: [],
  initiative: { modifier: 0, override: null },
  level1ChoiceType: "",
  notes: "",
  selectedFeat: "",
  selectedInnateHeritage: "",
  created_at: "",
  updated_at: "",
};

export const ABILITY_SCORES = [
  "strength",
  "dexterity",
  "constitution",
  "intelligence",
  "wisdom",
  "charisma",
];

// D&D 5e Classes - fetched from API but listed here for reference
export const DND_CLASSES = [
  { index: "barbarian", name: "Barbarian" },
  { index: "bard", name: "Bard" },
  { index: "cleric", name: "Cleric" },
  { index: "druid", name: "Druid" },
  { index: "fighter", name: "Fighter" },
  { index: "monk", name: "Monk" },
  { index: "paladin", name: "Paladin" },
  { index: "ranger", name: "Ranger" },
  { index: "rogue", name: "Rogue" },
  { index: "sorcerer", name: "Sorcerer" },
  { index: "warlock", name: "Warlock" },
  { index: "wizard", name: "Wizard" },
];

// Hit dice by class
export const CLASS_HIT_DICE = {
  // D&D 5e Classes
  barbarian: "d12",
  bard: "d8",
  cleric: "d8",
  druid: "d8",
  fighter: "d10",
  monk: "d8",
  paladin: "d10",
  ranger: "d10",
  rogue: "d8",
  sorcerer: "d6",
  warlock: "d8",
  wizard: "d6",
  // Custom Wizard World Classes
  base_witch_wizard: "d8",
  profession_healer_alchemist: "d8",
  profession_spellwright: "d8",
  profession_naturalist: "d8",
  profession_auror: "d10",
  profession_wordsmith: "d8",
  profession_hitwizard: "d8",
  profession_field_hunter: "d10",
  profession_muggle_liaison: "d8",
};
